export const CREATE_UI_TOAST = 'CREATE_UI_TOAST';
export const DISMISS_UI_TOAST = 'DISMISS_UI_TOAST';
export const DELETE_UI_TOAST = 'DELETE_UI_TOAST';
export const CLEAR_UI_TOAST = 'CLEAR_UI_TOAST';
